import { Component } from "../component"
import { iterable } from "../helpers/iterable"

export class SectionSearch extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      sortInputs: "input[name='sort_by']",
    }
  }

  attachEvents() {
    const { sortInputs } = this.$ui

    iterable(sortInputs).forEach((input) => {
      input.addEventListener("click", () => {
        const searchParams = new URLSearchParams(window.location.search)
        searchParams.set("sort_by", input.value)
        window.location.search = searchParams.toString()
      })
    })
  }

  created() {
    this.attachEvents()
  }
}
